import React from 'react';
import { useT } from './BuilderApp.jsx';

const COLORS = ['#3b82f6', '#818cf8', '#c084fc', '#34d399', '#fb923c', '#fbbf24'];
const DOTS = [...Array(14)].map((_, i) => ({
  top: 10 + Math.random() * 75,
  left: Math.random() * 100,
  w: 5 + Math.random() * 4,
  dur: 2.5 + Math.random() * 2.5,
  delay: Math.random() * 2,
  color: COLORS[i % COLORS.length],
}));

export default function SuccessScreen({ config, buildResult }) {
  const t = useT();
  const siteResult = buildResult;
  const domain = siteResult?.live_url
    ? siteResult.live_url.replace(/^https?:\/\//, '')
    : config.custom_domain || (config.slug ? `${config.slug}.chamcore.site` : 'your-site.chamcore.site');
  const liveUrl = siteResult?.live_url || `https://${domain}`;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', position: 'relative', zIndex: 1, textAlign: 'center' }}>
      {/* Floating dots background */}
      <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', overflow: 'hidden', zIndex: 0 }}>
        {DOTS.map((d, i) => (
          <div key={i} style={{
            position: 'absolute',
            top: `${d.top}%`, left: `${d.left}%`,
            width: d.w, height: d.w, borderRadius: '50%',
            background: d.color, opacity: .55,
            animation: `float ${d.dur}s ease-in-out ${d.delay}s infinite alternate`,
          }}/>
        ))}
      </div>

      <div style={{ maxWidth: 520, width: '100%', position: 'relative', zIndex: 1 }}>
        <div style={{ fontSize: '3.5rem', marginBottom: '1rem' }}>🚀</div>
        <h1 style={{ fontSize: '2.2rem', fontWeight: 900, letterSpacing: '-.03em', marginBottom: '.6rem' }}>
          {t.succ_h} <span className="grad">{t.succ_grad}</span>
        </h1>
        <p style={{ color: 'var(--muted)', marginBottom: '2rem', fontSize: '.93rem', lineHeight: 1.65, maxWidth: 400, margin: '0 auto 2rem' }}>
          {t.succ_sub(config.branding.company_name || 'Your business')}
        </p>

        {/* Live URL box */}
        <div style={{ background: 'rgba(52,211,153,.07)', border: '1px solid rgba(52,211,153,.2)', borderRadius: 14, padding: '1.1rem 1.25rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem' }}>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '.68rem', fontWeight: 700, color: 'var(--green)', letterSpacing: '.06em', marginBottom: '.25rem', textTransform: 'uppercase' }}>{t.succ_url}</div>
            <div style={{ fontFamily: 'monospace', fontSize: '.88rem', color: 'var(--text)', wordBreak: 'break-all' }}>{liveUrl}</div>
          </div>
          <button className="btn btn-ghost btn-sm" onClick={() => window.open(liveUrl, '_blank')} style={{ flexShrink: 0 }}>{t.succ_open}</button>
        </div>

        {siteResult?.client_uid && (
          <p style={{ fontSize: '.71rem', color: 'var(--dim)', marginBottom: '1rem', fontFamily: 'monospace' }}>
            Client ID: {siteResult.client_uid}
          </p>
        )}

        <div style={{ display: 'flex', gap: '.85rem', flexDirection: 'column' }}>
          <button className="btn btn-primary btn-lg btn-full" onClick={() => window.open('/dashboard', '_blank')}>{t.succ_dash}</button>
          <button className="btn btn-ghost btn-lg btn-full" onClick={() => window.open(liveUrl, '_blank')}>{t.succ_view}</button>
        </div>
        <p style={{ marginTop: '1.5rem', fontSize: '.75rem', color: 'var(--dim)' }}>{t.succ_email(config.owner_email)}</p>
      </div>
    </div>
  );
}
